import filter from "@/api/filter";

export const infoTableColumns = [
  {
    title: '姓名',
    key: 'name',
    align: 'center'
  },
  {
    title: '证件号码',
    key: 'idNo',
    align: 'center'
  },
  {
    title: '与被保险人关系',
    align: 'center',
    render(h, params) {
      const value = filter.filterRelationShip(
        params.row.insuranceRelation
      );
      return <span>{value}</span>;
    }
  },
  {
    title: '收益比例',
    key: 'benefitScale',
    align: 'center'
  }
]

export const infoTableColumns2 = [
  {
    title: "姓名",
    key: "name",
    align: "center"
  },
  {
    title: "证件号码",
    key: "cardNumber",
    align: "center"
  },
  {
    title: "与被保险人关系",
    align: "center",
    render(h, params) {
      const value = filter.filterRelationShip(
        params.row.relationToHolder
      );
      return <span>{value}</span>;
    }
  },
  {
    title: "受益比例",
    key: "rate",
    align: "center",
    render(h, params) {
      return <span>{params.row.rate + "%"}</span>;
    }
  }
]

export const payRecordColumns = [
  {
    title: '应续日',
    align: 'center',
    render(h, params) {
      const needPayDate = params.row.needPayDate;
      const result = filter.filterTime(needPayDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  },
  {
    title: '交费期数',
    key: 'curRenewalTimes',
    align: 'center'
  },
  {
    title: '交费方式/第几次交费',
    key: 'payTypeAndRenewalTimes',
    align: 'center'
  },
  {
    title: '状态',
    key: 'payState',
    align: 'center'
  },
  {
    title: '应交保费(元)',
    key: 'fee',
    align: 'center'
  },
  {
    title: '实收保费(元)',
    key: 'payFee',
    align: 'center'
  },
  {
    title: '实际交费日期',
    align: 'center',
    render(h, params) {
      const serverEndDate = params.row.serverEndDate;
      const result = filter.filterTime(serverEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  },
  {
    title: '宽限期满日',
    align: 'center',
    render(h, params) {
      const lastPayDate = params.row.lastPayDate;
      const result = filter.filterTime(lastPayDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    },
  }
]
